module.exports = __webpack_public_path__ + "img/7.a4aba89a.jpg";